export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10478.a61eb250.jpg";